module.exports = __webpack_public_path__ + "static/media/2025_2026_UIL_Region_20_Judges_List.8f8ddab0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/2025_2026_UIL_Region_20_Judges_List.pdf
// module id = 255
// module chunks = 0